/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Inventor Automation team
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////
import React, { Component } from 'react';
import {connect} from 'react-redux';
import ProjectAccountSwitcher from '@hig/project-account-switcher';
import { fetchProjects, updateActiveProject } from '../actions/projectListActions';
import { updateActiveTabIndex, invalidateDrawing } from '../actions/uiFlagsActions';
import { fetchParameters } from '../actions/parametersActions';
import {addLog} from '../actions/notificationActions';
import authService from '../services/authService';
import './projectSwitcher.css';

export class ProjectSwitcher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowedProjects: null,
            loading: true
        };
        this.onProjectClick = this.onProjectClick.bind(this);
    }

    componentDidMount() {
        this.props.fetchProjects();
        this.loadAllowedProjects();
    }

    componentDidUpdate(prevProps, prevState) {
        // When projects load or allowed projects change, ensure active project is valid
        const filteredProjects = this.getFilteredProjects();
        
        if (filteredProjects.length > 0 && !this.state.loading) {
            const activeProject = this.props.projectList.activeProjectId;
            const activeInList = filteredProjects.some(p => p.id === activeProject);
            
            // If current active project is not in the filtered list, switch to first available
            if (!activeInList) {
                this.props.updateActiveProject(filteredProjects[0].id);
            }
        }
    }

    async loadAllowedProjects() {
        // Access control is enforced server-side via Products.CompanyId
        this.setState({ allowedProjects: null, loading: false });
    }

    getFilteredProjects() {
        if (!this.props.projectList || !this.props.projectList.projects) {
            return [];
        }

        const projects = this.props.projectList.projects;

        // If allowedProjects is null, show all (admin or no restrictions)
        if (this.state.allowedProjects === null) {
            return projects;
        }

        // Filter to only allowed projects
        return projects.filter(project => 
            this.state.allowedProjects.includes(project.id) || 
            this.state.allowedProjects.includes(project.label)
        );
    }

    onProjectClick(event) {
        const id = event.target.lastChild.textContent;
        this.props.updateActiveProject(id);
        this.props.invalidateDrawing();
        this.props.updateActiveTabIndex(1);
        this.props.addLog('Selected: ' + id);
    }

    render() {
        if (this.state.loading) {
            return <span id="PAS"></span>;
        }
        
        const filteredProjects = this.getFilteredProjects();
        
        if (!filteredProjects || filteredProjects.length === 0) {
            return <span id="PAS"><span className="no-projects">No projects available</span></span>;
        }
        
        const activeProject = this.props.projectList.activeProjectId;
        
        return (
            <span id="PAS">
            <ProjectAccountSwitcher
                key={activeProject}
                defaultProject={null}
                activeProject={activeProject}
                projects={filteredProjects}
                projectTitle="Projects"
                onClick={this.onProjectClick}
            />
            </span>
        );
    }
}

/* istanbul ignore next */
export default connect(function (store){
    return {
      projectList: store.projectList
    };
  }, { fetchProjects, fetchParameters, updateActiveProject, updateActiveTabIndex, addLog, invalidateDrawing } )(ProjectSwitcher);